import { gql } from '@lichtblick/apollo';

export const GET_WORK_GROUP = gql`
  query GetWorkGroup_V1($input: GetWorkGroupInput!) {
    getWorkGroup_V1(input: $input) {
      error
      data {
        id
        name
        approvalState
        items {
          id
          name
          approvalState
          modifiedAtUtc
        }
        workCategory {
          id
          name
        }
      }
    }
  }
`;
